import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { STORAGE_KEY_LOCALE_LANG } from './constants';
import envConfig from './env';
import configureYup from './configureYup';

function i18nInit() {
  return i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init({
    defaultNS: 'common',
    fallbackNS: 'common',
    ns: ['common'],
    load: 'currentOnly',
    fallbackLng: (code) => {
      if (code && typeof code === 'string' && code.includes('"')) {
        code = JSON.parse(code);
      }
      return code ?? envConfig.locale.default ?? 'fa';
    },
    debug: false,
    lowerCaseLng: true,
    backend: {
      loadPath: ([lng], [ns]) => {
        if (((lng ?? '') as string).includes('"')) {
          lng = JSON.parse(lng);
        }
        return `${envConfig.appBasePath || ''}/locales/${lng}/${ns}.json?v=${APP_VERSION}&time=${Date.now()}`;
      },
    },
    detection: {
      lookupLocalStorage: STORAGE_KEY_LOCALE_LANG,
      order: ['localStorage', 'cookie'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });
}

i18nInit();
configureYup();

export default i18nInit;
